module.exports = __webpack_public_path__ + "static/external/Confluence_Slack.d96e327b29adffa28a12478764670f84.png";